import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgMinus = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M7 12.667h10.667v-1.334H7z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgMinus);
export default Memo;
